import logoOfficialSrc from "../../assets/logo-official.svg";

interface LogoProps {
  mono?: boolean; // kept for API compatibility; no-op for the official SVG (no mono variant)
  size?: number;
  className?: string;
}

export default function Logo({ size = 160, className }: LogoProps) {
  return (
    <img
      src={logoOfficialSrc}
      alt="Фонд Притула"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
